import { useState, useEffect } from 'react';
import { SEO } from '../../components/seo/SEO';
import { HeroSection } from './components/HeroSection';
import { FeaturedArticles } from './components/FeaturedArticles';
import { SeriesSection } from './components/SeriesSection';
import { CategorySection } from './components/CategorySection';
import { LatestArticles } from './components/LatestArticles';
import { MissionSection } from './components/MissionSection';
import { supabase, Post } from '../../lib/supabase';
import { getBaseUrl } from '../../lib/utils';

export default function HomePage() {
  const baseUrl = getBaseUrl();
  const [posts, setPosts] = useState<Post[]>([]);

  useEffect(() => {
    const fetchPosts = async () => {
      try {
        const { data, error } = await supabase
          .from('posts')
          .select('*')
          .lte('published_at', new Date().toISOString())
          .order('published_at', { ascending: false });
        if (error) throw error;
        setPosts(data || []);
      } catch {
        setPosts([]);
      }
    };
    fetchPosts();
  }, []);

  const jsonLd = {
    '@context': 'https://schema.org',
    '@graph': [
      {
        '@type': 'WebSite',
        name: 'つくってなんぼ',
        url: baseUrl,
        description: 'AIを使って作る・整える・速くする。実践型の編集メディア。',
        potentialAction: {
          '@type': 'SearchAction',
          target: `${baseUrl}/search?q={search_term_string}`,
          'query-input': 'required name=search_term_string',
        },
      },
    ],
  };

  return (
    <>
      <SEO
        title="つくってなんぼ | AI実践メディア——作って、詰まって、直したところまで残す"
        description="AIツール活用・UI再現・制作フロー・バイブコーディング。実際に作って詰まって直した過程を、再現できる形で整理する実践メディア。"
        canonical="/"
        jsonLd={jsonLd}
      />
      <div className="min-h-screen bg-[#FDFAF6]">
        <HeroSection />
        <FeaturedArticles posts={posts} />
        <SeriesSection />
        <CategorySection />
        <LatestArticles posts={posts} />
        <MissionSection />
      </div>
    </>
  );
}
